import React, {useRef} from "react";
import {Button, Card, Col, Row, Form, Input, Select, Spin} from "antd";
import {
  BankOutlined, CaretDownOutlined, GlobalOutlined,
  HomeOutlined, LoadingOutlined, LockOutlined,
  MailOutlined, PhoneOutlined, SearchOutlined,
  UserOutlined
} from "@ant-design/icons";
import {countries} from "../../../data/countries";
import ReCAPTCHA from "react-google-recaptcha";
import {RECAPTCHA_SITE_KEY} from "../../../constants";


export const CompanyForm = (props) => {
  const { isRegistering } = props;
  const recaptchaRef = useRef(null)

  const handleClick = async (values) => {
    props.handleClick({...values, region: values.city}).then(()=>{
      if(recaptchaRef?.current) {
        recaptchaRef.current.reset();
      }
    }).catch(()=>{
      if(recaptchaRef?.current) {
        recaptchaRef.current.reset();
      }
    })
  }

  return (
    <Row>
      <Col span={24}>
        <Form
          name={'register-company-personal'}
          onFinish={handleClick}
        >
          <Card
            size={"small"}
            className={"registrationCard"}
          >
            <Row gutter={18}>
              <Col span={8} style={{borderRight: "1px solid #dadada"}}>
                <span className={"registrationLabel"}>Email</span>
                <Form.Item
                  name={'email'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'email', message: 'Please enter a valid email address'},
                  ]}
                  validateTrigger={'onSubmit'}

                >
                  <Input
                    className={"loginInputText"}
                    placeholder="Enter your email address"
                    prefix={<MailOutlined />}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{borderRight: "1px solid #dadada"}}>
                <span className={"registrationLabel"}>Country</span>
                <Form.Item
                  name={'country'}
                  rules={[
                    {required: true, message: 'This field is required'},
                  ]}
                  validateTrigger={'onSubmit'}
                  className={"whiteSelectItem"}
                >
                  <Select
                    showSearch
                    className={"whiteSelect"}
                    dropdownClassName={"whiteSelectDropdown"}
                    style={{width: '100%'}}
                    prefix={<GlobalOutlined />}
                    suffixIcon={(e) => {
                      return e.focused ? <SearchOutlined/> : <CaretDownOutlined/>
                    }}
                    placeholder="Select your country"
                    optionFilterProp="children"
                    notFoundContent={"Country not found"}
                    filterOption={(input, option) =>
                      option.children[2].toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    autoComplete="new-password"
                  >
                    {
                      countries.map(item => {
                        return (
                          <Select.Option key={item.name} value={item.name} className={"countrySelectWhite"}>
                            <img src={item.flag} alt="" style={{position: "relative", top: -2, width: 18}}/> {item.name}
                          </Select.Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} style={{borderRight: "1px solid #dadada"}}>
                <span className={"registrationLabel"}>Address</span>
                <Form.Item
                  name={'address'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 2 ,message: 'Too short!'},
                    {type: 'string', max: 60 ,message: 'Too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    className={"loginInputText"}
                    placeholder="Enter your address"
                    prefix={<HomeOutlined />}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={18}>
              <Col span={8} style={{borderRight: "1px solid #dadada"}}>
                <span className={"registrationLabel"}>Password</span>
                <Form.Item
                  name={'password'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 6 ,message: 'Too short!'},
                    {type: 'string', max: 60 ,message: 'Too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input.Password
                    className={"loginInputText"}
                    placeholder="Enter your password"
                    prefix={<LockOutlined />}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{borderRight: "1px solid #dadada"}}>
                <span className={"registrationLabel"}>City</span>
                <Form.Item
                  name={'city'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 2 ,message: 'Too short!'},
                    {type: 'string', max: 60 ,message: 'Too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    className={"loginInputText"}
                    placeholder="Enter your city"
                    prefix={<GlobalOutlined />}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <span className={"registrationLabel"}>Contact Name</span>
                <Form.Item
                  name={'contactName'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 2 ,message: 'Too short!'},
                    {type: 'string', max: 60 ,message: 'Too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    className={"loginInputText"}
                    placeholder="Enter your contact first name"
                    prefix={<UserOutlined />}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={18}>
              <Col span={8} style={{borderRight: "1px solid #dadada", height: 55}}>
                <div style={{height: 74}}>
                  <span className={"registrationLabel"}>Company Name</span>
                  <Form.Item
                    name={'name'}
                    rules={[
                      {required: true, message: 'This field is required'},
                      {type: 'string', min: 2 ,message: 'Too short!'},
                      {type: 'string', max: 60 ,message: 'Too long!'},
                    ]}
                    validateTrigger={'onSubmit'}
                  >
                    <Input
                      className={"loginInputText"}
                      placeholder="Enter your company name"
                      prefix={<BankOutlined />}
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col span={8} style={{borderRight: "1px solid #dadada", height: 55}}>
                <div style={{height: 74}}>
                  <span className={"registrationLabel"}>Postal Code</span>
                  <Form.Item
                    name={'postalCode'}
                    rules={[
                      {required: true, message: 'This field is required'},
                      {type: 'string', min: 3 ,message: 'Too short!'},
                      {type: 'string', max: 60 ,message: 'Too long!'},
                    ]}
                    validateTrigger={'onSubmit'}
                  >
                    <Input
                      className={"loginInputText"}
                      prefix={<GlobalOutlined />}
                      placeholder="Enter your postal code"
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col span={8}>
                <span className={"registrationLabel"}>Phone</span>
                <Form.Item
                  name={'phone'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 6 ,message: 'Too short!'},
                    {type: 'string', max: 60 ,message: 'Too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    className={"loginInputText"}
                    placeholder="Enter your contact phone number"
                    prefix={<PhoneOutlined />}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div style={{display: "flex", justifyContent: "center"}}>
              <div style={{position: "absolute", marginTop: 25}}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}/>
              </div>
              <div style={{textAlign: "left", zIndex: 2}}>
                <Form.Item
                  name={"reCaptcha"}
                  rules={[
                    {required: true, message: 'reCaptcha is required'},
                  ]}
                  className={"reCaptchaFormItem"}
                  validateTrigger={'onSubmit'}
                >
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={RECAPTCHA_SITE_KEY}
                  />
                </Form.Item>
              </div>
            </div>
          </Card>
          <Form.Item>
            <div style={{display: "flex", width: '100%', justifyContent: "center"}}>
              <Button
                style={{width: '100%', marginTop: '10px', maxWidth: 500}}
                type="primary"
                htmlType="submit"
                className={"blackButton"}
                loading={isRegistering}
              >
                Sign Up
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
}


